<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Departamentos
  </app-header-dialog>

  <div *ngIf="entityForm">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Capa</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 300px;' appearance="outline">
            <mat-label>Sigla</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.short"
              autocomplete="off">

          </mat-form-field>
          <mat-form-field style='width: 900px;' appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 900px;' appearance="outline">
            <mat-label>Mensagem alternativa</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.message"
              autocomplete="off">
          </mat-form-field>

          <div>
            <mat-checkbox color='primary' [formControl]="entityForm.controls.canPublish">
              Publicar
            </mat-checkbox>
          </div>


        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings</mat-icon>
          <div>Contexto</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 240px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.context" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>question_answer</mat-icon>
          <div>Prompt</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 220px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.prompt" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>preview</mat-icon>
          <div>Preview</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 240px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.preview" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>open_in_browser</mat-icon>
          <div>HTML</div>
        </ng-template>

        <div class="content">

          <mat-form-field style='width: 100%;' appearance="outline">
            <textarea style="height: calc(100vh - 240px);" matInput [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.html" autocomplete="off">
              </textarea>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>manage_search</mat-icon>
          <div>Arquivos</div>
        </ng-template>

        <div class="content">
          <app-file-manager [image_path]="image_path">
          </app-file-manager>
        </div>

      </mat-tab>

    </mat-tab-group>

    <div class="actions">

      <button matTooltip='Publicar' mat-raised-button (click)='publishContent()'>
        <mat-icon>publish</mat-icon>
      </button>

      <div>

        <button matTooltip='Gemini' mat-raised-button (click)='generateGeminiContent()'>
          <mat-icon class='icon-ia'>lightbulb_outlin</mat-icon>
        </button>

        <button matTooltip='Prévia' mat-raised-button (click)='previewContent()'>
          <mat-icon class='icon-add'>preview</mat-icon>
        </button>

        <button matTooltip='Salvar' mat-raised-button (click)='update()'>
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

        <button *ngIf="!isEdit" matTooltip='Salvar' mat-raised-button
          (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
          <mat-icon class='icon-done'>check_circle</mat-icon>
        </button>
        <button *ngIf="isEdit" matTooltip='Salvar & Fechar' mat-raised-button
          (click)="matDialogRef.close(['update', entityForm])" [disabled]="entityForm.invalid">
          <mat-icon class='icon-done'>check_circle</mat-icon>
        </button>

      </div>

    </div>

  </div>

</div>